<!-- Contact Fundraiser -->
<div class="dialog">
  <div class="close">
    <button (click)="dialog.closeAll(); startFRForm.reset()" mat-icon-button><mat-icon>close</mat-icon></button>
  </div>
  <div class="content-container">
    <div class="title">Start a Supporting Fundraiser</div>
    <div class="img-container">
      <button (click)="openFileUpload()" mat-icon-button>
        <mat-icon [hidden]="userdata?.avtar?.cdn_path" class="icon-user1"></mat-icon>
        <img loading="lazy" #profileSrcRef class="pro-img" [hidden]="!userdata?.avtar?.cdn_path" [src]="userdata?.avtar?.cdn_path" [alt]="'User Pic - '+userdata?.full_name" />
        <mat-icon class="camera">camera_alt</mat-icon>
      </button>
      <div class="add-img">
        <div (click)="openFileUpload()"><span>Add Image</span></div>
        <div (click)="facebookConnect()" class="fb-text">
          <mat-icon class="icon-fb"></mat-icon> <span class="fb-txt">Connect</span>
        </div>
      </div>
    </div>
    <form [formGroup]="startFRForm" class="form" (ngSubmit)="submit(sfSumitted)">
      <div class="amount">
        <span class="amount-icon" [innerHTML]="'&#x20b9;' | safeHtml"></span>
        <mat-form-field class="amount-input">
          <mat-label>Goal Amount</mat-label>
          <input matInput type="tel" formControlName="amount">
          <mat-error *ngIf="amount.hasError('required') && amount.touched">This field is required</mat-error>
          <mat-error *ngIf="amount.hasError('min') && amount.touched">The minimum goal amount is &#x20b9; 2000!</mat-error>
          <mat-error *ngIf="amount.hasError('max') && amount.touched">The maximum goal amount is &#x20b9; 5 Crores</mat-error>
          <mat-error *ngIf="amount.hasError('pattern') && amount.touched">Invalid Amount</mat-error>
        </mat-form-field>
      </div>
      <mat-form-field class="input-container mt-1" appearance="fill">
        <mat-label>Make an Appeal</mat-label>
        <textarea class="text-area" matInput
                  formControlName="appeal"
                  maxlength="800">
        </textarea>
        <mat-hint align="end">{{appeal.value?.length || 0}}/800</mat-hint>
        <mat-error *ngIf="appeal.hasError('required') && appeal.touched">This field is required</mat-error>
        <mat-error *ngIf="appeal.hasError('minlength') && appeal.touched">Please enter atleast 5 characters</mat-error>
      </mat-form-field>
      <div class="captcha-container">
        <app-captcha-input #captchaRef [control]="captcha" type="dialog"></app-captcha-input>
        <button type="submit" class="submit-btn" mat-raised-button [disabled]="disableStartFR">
          <span *ngIf="!disableStartFR">Start my Fundraiser</span>
          <div *ngIf="disableStartFR" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </button>
      </div>
    </form>
  </div>
</div>

<!-- file upload for image -->
<input #profilePic class="d-none" type="file" (change)="fileChangeEvent($event)">
<!-- Facebook login -->
<app-fb-login #fbLogin class="d-none" [closeDialog]="false" (loginResponse)="getFbResponse($event)"></app-fb-login>

<ng-template #sfSumitted>
  <div class="sfSumitted-container">
    <button class="close" (click)="closeDialog()" mat-icon-button>
      <i class="material-icons">close</i>
    </button>
    <h3 class="header">
      Your Supporting Fundraiser is under review
    </h3>
    <span class="msg">
      Our team is reviewing your Supporting Fundraiser. You will receive an email regarding its status within 2 working days.
    </span>
  </div>
</ng-template>
